import React, { useState } from "react";
import Select from "react-select";
import { auth } from "../../../utils/auth";
import { formatNumber } from "../../../utils/helpers";
import { opcionesUnidades, aCantidadBase, aCantidadUnidad } from "../../../utils/unidades";

const Form = ({ producto, ajuste, errors }) => {
    if (!ajuste) {
        ajuste = {};
    }
    const [incrementar, setIncrementar] = useState("yes");

    // El ajuste se captura en cualquier unidad del producto; el backend lo
    // convierte a base con el factor del catálogo y mueve el stock en base.
    const opciones = opcionesUnidades(producto);
    const base = opciones.find((o) => o.es_base) ?? opciones[0];
    const [unidad, setUnidad] = useState(base);
    const [cantidad, setCantidad] = useState(ajuste.cantidad ?? "");
    const factor = unidad?.factor || 1;

    return (
        <div className='popup__body'>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>
                        Tipo de Ajuste:
                    </label>
                </div>
                <div className='col col-md-8'>
                    <select
                        type='date'
                        name='incrementar'
                        className='form-control'
                        onChange={e => setIncrementar(e.target.value)}
                        defaultValue={incrementar}>
                        <option value='yes'>Incrementar</option>
                        <option value='no'>Reducir</option>
                    </select>
                </div>
                <input type='hidden' name='producto_id' value={producto.id} />
                <input type="hidden" name="user_id" value={auth.getUser().id} />
                <input type="hidden" name="unidad_id" value={unidad?.unidad_id ?? ""} />
            </div>
            {opciones.length > 1 && (
                <div className='row form-group'>
                    <div className='col col-md-4'>
                        <label className='label form-control-label'>
                            Unidad:
                        </label>
                    </div>
                    <div className='col col-md-8'>
                        <Select
                            options={opciones}
                            value={unidad}
                            onChange={setUnidad}
                        />
                    </div>
                </div>
            )}
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>
                        Cantidad:
                    </label>
                </div>
                <div className='col col-md-8'>
                    <input
                        type='number'
                        step='0.01'
                        className='text-input form-control'
                        id='cantidad'
                        name='cantidad'
                        // La existencia está en unidad base: al reducir sólo
                        // alcanzan las unidades completas de la elegida.
                        max={incrementar === "no" ? Math.floor(aCantidadUnidad(producto.cantidad, factor)) : ""}
                        value={cantidad}
                        onChange={(e) => setCantidad(e.target.value)}
                    />
                    {factor > 1 && cantidad !== "" && (
                        <small className='form-text text-muted'>
                            = {formatNumber(aCantidadBase(cantidad, factor))} {base?.value}
                        </small>
                    )}
                    {errors.cantidad && (
                        <small className='help-blockParams form-Text'>
                            {errors.cantidad[0]}
                        </small>
                    )}
                </div>
            </div>
            <div className='row form-group'>
                <div className='col col-md-4'>
                    <label className='label form-control-label'>Motivo:</label>
                </div>
                <div className='col col-md-8'>
                    <textarea
                        type='text'
                        name='descripcion'
                        rows='5'
                        className='form-control'
                        defaultValue={ajuste.descripcion}
                    />
                    {errors.descripcion && (
                        <small className='help-blockParams form-Text'>
                            {errors.descripcion[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Form;
